module.exports = __webpack_public_path__ + "static/media/sketch3.0b800ad2.jpg";